import cn from 'clsx'

// Components
import { Pill } from '@tracklib/kit'
import Genres from 'components/base/infoitem2/genres'
import Regions from 'components/base/infoitem2/regions'
import Labels from 'components/base/infoitem2/labels'
import Key from 'components/base/infoitem2/key'
import Year from 'components/base/infoitem2/year'
import LicenseInfo from 'components/base/infoitem2/licenseinfo'

import { Genre, Region, Label, LicenseInfo as LicenseInfoType } from 'types'

import styles from './infoitem2.css'

type InfoItem2Props = {
  title?: string
  genres?: Array<Genre>
  labels?: Array<Label>
  regions?: Array<Region>
  tonal?: string
  year?: string | number
  licenseInfo?: LicenseInfoType
  showAll?: boolean
  displayAsRow?: boolean
  isModal?: boolean
  modalOpen?: boolean
  toggleModalOpen?: () => null
}

const InfoItem2 = ({
  title,
  genres,
  labels,
  regions,
  tonal,
  year,
  licenseInfo,
  isModal = false,
  modalOpen,
  toggleModalOpen,
  showAll,
  displayAsRow,
}: InfoItem2Props): JSX.Element => {
  let displayTitle = ''
  if (title) {
    displayTitle = title
  } else if (genres?.length) {
    displayTitle = genres.length > 1 ? 'Genres' : 'Genre'
  } else if (regions) {
    displayTitle = regions.length > 1 ? 'Regions' : 'Region'
  } else if (labels) {
    displayTitle = labels.length > 1 ? 'Labels' : 'Label'
  } else if (tonal) {
    displayTitle = 'Key'
  } else if (year) {
    displayTitle = 'Release year'
  } else if (licenseInfo) {
    displayTitle = 'License info'
  }

  const renderLinks = (): JSX.Element | null => {
    if (genres) {
      return (
        <Genres
          genres={genres}
          showAll={showAll}
          displayAsRow={displayAsRow}
          isModal={isModal}
          modalOpen={modalOpen}
          toggleModalOpen={toggleModalOpen}
        />
      )
    }
    if (regions) {
      return (
        <Regions
          regions={regions}
          showAll={showAll}
          displayAsRow={displayAsRow}
          isModal={isModal}
          modalOpen={modalOpen}
          toggleModalOpen={toggleModalOpen}
        />
      )
    }
    if (labels) {
      return (
        <Labels
          labels={labels}
          showAll={showAll}
          displayAsRow={displayAsRow}
          isModal={isModal}
          modalOpen={modalOpen}
          toggleModalOpen={toggleModalOpen}
        />
      )
    }
    if (tonal) {
      return <Key tonal={tonal} />
    }
    if (year) {
      return <Year year={year} />
    }
    if (licenseInfo) {
      return <LicenseInfo licenseInfo={licenseInfo} displayAsRow />
    }

    return null
  }

  return (
    <li className={styles.wrapper}>
      <Pill size="small" datatesting="sidepanel_titles" className={styles.title}>
        {displayTitle}
      </Pill>
      <div className={cn(displayAsRow ? styles.listRow : styles.listColumn)}>{renderLinks()}</div>
    </li>
  )
}

export default InfoItem2
